// #flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";
import { config } from "dotenv";

const description =
  "A widget used to display a series of images and videos to the user.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Multimedia gallery",
  id: "multimedia-gallery",
  warningMsgOnConfigOverlay: {
    head: "Warning:",
    body:
      "You have changed the shape of this gallery. Existing images will remain cropped to their old shapes so please ensure you re-crop them to the new sizes."
  },
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/multimedia-gallery/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PhotoGalleryConfigTool" */ "app/components/tools/MultimediaGalleryConfigTool/MultimediaGalleryConfigTool"),
    loading: DynamicImportLoader,
    modules: ["MultimediaGalleryConfigTool"]
  })
};

export default CONFIG;
